export const ResourceType = {
  TICKET: "TICKET",
  ESCALATION: "ESCALATION",
  SITE_ACCESS: "SITE_ACCESS",
  NTDC_CONTRACT: "NTDC_CONTRACT",
  NTDC_CUSTOMER: "NTDC_CUSTOMER",
  NTDC_CONTACT_AND_SALE: "NTDC_CONTACT_AND_SALE",
  IPAM: "IPAM",
  REPORT: "REPORT"
}

export const ResourceTypeIcon = {
  [ResourceType.TICKET]: "TagIcon",
  [ResourceType.ESCALATION]: "ChevronsUpIcon",
  [ResourceType.SITE_ACCESS]: "MaximizeIcon",
  [ResourceType.NTDC_CONTRACT]: "DatabaseIcon",
  [ResourceType.NTDC_CUSTOMER]: "DatabaseIcon",
  [ResourceType.NTDC_CONTACT_AND_SALE]: "DatabaseIcon",
  [ResourceType.IPAM]: "HashIcon",
  [ResourceType.REPORT]: "FileTextIcon"
}

export const ResourceTypeHeader = {
  [ResourceType.TICKET]: "Ticket",
  [ResourceType.ESCALATION]: "Escalation Template",
  [ResourceType.SITE_ACCESS]: "Site Access",
  [ResourceType.NTDC_CONTRACT]: "NTDC Contract",
  [ResourceType.NTDC_CUSTOMER]: "NTDC Customer",
  [ResourceType.NTDC_CONTACT_AND_SALE]: "NTDC Contact Point & Sale",
  [ResourceType.IPAM]: "IPAM",
  [ResourceType.REPORT]: "Report"
}

export const ResourceTypeOptions = [
  { value: ResourceType.TICKET, name: "Ticket Management" },
  { value: ResourceType.ESCALATION, name: "Escalation Template" },
  { value: ResourceType.SITE_ACCESS, name: "Site Access" },
  { value: ResourceType.NTDC_CONTRACT, name: "NTDC Contract" },
  { value: ResourceType.NTDC_CUSTOMER, name: "NTDC Customer" },
  {
    value: ResourceType.NTDC_CONTACT_AND_SALE,
    name: "NTDC Contact Point & Sale"
  },
  { value: ResourceType.IPAM, name: "IPAM" },
  { value: ResourceType.REPORT, name: "Report" }
]

export const ResourceRouteMap = {
  TICKET: "internalTicketDetail",
  ESCALATION: "escalationTemplateDetail",
  SITE_ACCESS: "internalSiteAccessDetail",
  NTDC_CONTRACT: "idcContractAction",
  NTDC_CUSTOMER: "idcEditCustomer",
  NTDC_CONTACT_AND_SALE: "idcEditContactPointOrSale",
  IPAM: "ipamManagement"
}
